<script setup lang="ts">
import DeliverySearchButtonPosition from '@/components/Delivery/DeliverySearchButtonPosition.vue'

import type { LatLng } from '@/api/modules/delivery/types'
import type { SuggestedOfAddress } from '@/api/modules/geo/geocode.types'

type Props = {
  errorMessages: string
  searchInputText: string | null
  selectedAutocompleteText: string | null
}

defineProps<Props>()

const emit = defineEmits([
  'update:search',
  'on-reset-value',
  'on-update-address-info',
  'on-update-field-address',
  'on-handle-error-geo-position',
])

const INPUT_TAG = 'input'

const { isMobile } = useResponsive()

const refInputSearchAddress = ref<HTMLElement | null>(null)

const onUpdateSelectedAddress = (
  selectedSuggestion: SuggestedOfAddress,
  coordinates: LatLng,
) => {
  emit('on-update-field-address', selectedSuggestion.value)
  emit('on-update-address-info', {
    selectedSuggestion,
    coordinates,
  })
}

// Сброс значения поля
const onResetValue = () => emit('on-reset-value')

const onHandleErrorGeoPosition = () => emit('on-handle-error-geo-position')

const inputHandler = (value: string) => emit('update:search', value)

// Смещение видимой области в конце input
const moveCursorToInput = () => {
  if (!isMobile.value || !refInputSearchAddress.value) return

  const inputElement: HTMLInputElement | null =
    refInputSearchAddress.value.querySelector(INPUT_TAG)

  if (!inputElement) return

  // Смещаем видимую область адреса в конец
  inputElement.scrollLeft = inputElement.scrollWidth
}
</script>

<template>
  <div class="search-input">
    <div ref="refInputSearchAddress" class="search-input-group">
      <the-input
        :width="isMobile ? '100%' : 294"
        :model-value="selectedAutocompleteText || undefined"
        name="address"
        label="Город, улица, дом"
        placeholder="Введите адрес"
        autocomplete="off"
        :error-messages="errorMessages"
        @update:model-value="inputHandler"
        @clear="onResetValue"
        @click="moveCursorToInput"
      />

      <delivery-search-button-position
        class="search-input-group__button-location"
        @set-delivery-address="onUpdateSelectedAddress"
        @on-handle-error-geo-position="onHandleErrorGeoPosition"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.search-input {
  display: flex;
  flex-direction: column;
  width: 100%;

  .search-input-group {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__button-location {
      margin-left: 10px;
    }
  }
}
</style>
